import LanguageSelected from './LanguageSelected';

export default LanguageSelected;
